import styles from '@/components/template/header/HeaderLogo/HeaderLogo.module.scss'
import ThemeImage from '@/components/elements/media/ThemeImage/ThemeImage'
import React from 'react'

const HeaderLogo = () => {
  return <ThemeImage src={`images/mandatory/logo.png`} height={36} width={130} alt={'logo'} lazyload={false} dpr={true} className={styles.root} />
}

export default HeaderLogo
